import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useTranslation } from '../../contexts/translation-context';
import { serializeDate } from './helpers';
import styles from './date-components.st.scss';
import { DayField } from './day-field';
import { MonthSelect } from './month-select';
import { YearField } from './year-field';
import { SupportedDateParts } from '../../utils/date-format-parts';
const dateComponents = {
  [SupportedDateParts.DAY]: DayField,
  [SupportedDateParts.MONTH]: MonthSelect,
  [SupportedDateParts.YEAR]: YearField
};
export const getDateComponent = datePart => {
  const Field = dateComponents[datePart];
  if (!Field) {
    return () => null;
  }
  return function DateComponent(_ref) {
    let {
      id,
      hidePlaceholder,
      onChange,
      values,
      errors,
      ...rest
    } = _ref;
    const {
      t
    } = useTranslation();
    const placeholderText = hidePlaceholder ? undefined : t(`field.date.placeholder.${datePart.toLowerCase()}`);
    const value = values[datePart];
    const hasError = errors[datePart];
    return /*#__PURE__*/React.createElement(Field, _extends({}, rest, {
      id: id,
      error: hasError,
      value: value,
      className: styles[datePart],
      "data-date-field": true,
      "data-hook": datePart,
      placeholder: placeholderText,
      onChange: newValue => onChange(serializeDate(newValue, datePart, values))
    }));
  };
};
//# sourceMappingURL=date-components.js.map